<template>
    <Header
        class="DatatableHeader"
        :header="pageHeader"
        :show-items="showItems"
        :status="status"
    >
        <template v-slot:actions>
            <!-- @slot Header actions  -->
            <slot name="actions"></slot>
        </template>

        <template v-slot:filters>
            <!-- @slot Table filters -->
            <slot name="tableFilters"></slot>
        </template>

        <template v-slot:info>
            <!-- @slot Table Information (mostly used for pagination info-->
            <slot name="tableInfo">
                <small
                    v-if="showItems"
                    :class="statusBuilder('DatatableHeader__info', status)"
                >
                    Showing {{ items.count }} of {{ items.total }}
                </small>
            </slot>
        </template>
    </Header>
</template>

<script>
import statusBuilder from 'status/statusBuilder';
import Header from '@/components/Basic/Elements/Header.vue';
import stat from 'status';
export default {
    name: "DatatableHeader",
    components: {
        Header,
    },
    props: {
        status: {
            type: String,
            default: stat.STANDBY
        },
        items: {
            type: Object,
            default: () => ({
                count: -1,
                total: -1
            })
        },
        pageHeader: {
            type: String,
            default: ''
        },
    },
    computed: {
        showItems(){
            return this.items.count > -1 && !!this.items.total;
        },
        showBottomBar(){
            return !!this.$slots.tableFilters || this.showItems;
        }
    },
    methods: {
        statusBuilder,
    }
};
</script>

<style lang="scss">
.DatatableHeader {
    margin-bottom: 0.5rem;
    &__bar{
        display:flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
        &--top{
            padding-bottom: 1rem;
            border-bottom: 1px solid $grey-100;
        }
    }
    &__header{
        @include loading(2rem, 100%);
    }
    &__info{
        color: $grey;
        white-space: nowrap;
        @include loading(1.5rem, 9rem);
    }
}
</style>